export { OfferType, OfferStatus } from '@superbet-group/offer.clients.lib'

// Sports with sets
export enum SetSports {
    volleyball = 1,
    tennis = 2,
    badminton = 14,
    tableTennis = 24
}
